<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      text-color="#7D74A2"
      @select="handleSelect"
      active-text-color="white">
      <el-menu-item v-for="(item,index) in navMenuList" :index="index.toString()" :key="index">
        {{item.text}}
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    navMenuList: {
      type: Array,
      default: null
    },
    activeIndex: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.$emit('handleSelect', key)
      // this.$router.push({
      //   name: this.navMenuList[key].pathName
      // })
    }
  }
}
</script>
<style lang="less" scoped>
.el-menu--horizontal{
  border-bottom-color: #7D74A2 !important;
  border-bottom: 2px solid #7D74A2 !important;
}
.is-active{
  background-color: #7D74A2 !important;
}
.el-menu-item{
  line-height: 30px !important;
  height: 30px !important;
  border-bottom: 0 !important;
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/base/navmenu/navmenu.vue